import useTransformedImageUrl from "@/shared/hooks/useTransformedImage";
import { MouseEvent } from "react";

interface ThumbnailPreviewProps {
  mediaId: string;
  cloudfrontUrl: string;
  isSelected: boolean;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
}

const ThumbnailPreview = ({
  cloudfrontUrl,
  isSelected,
  onClick,
}: ThumbnailPreviewProps) => {
  const { transformedImageUrl } = useTransformedImageUrl(cloudfrontUrl);

  return (
    <div
      onClick={onClick}
      className={`w-16 h-16 bg-cover bg-center bg-no-repeat cursor-pointer border-2 ${
        isSelected
          ? "border-white"
          : "border-transparent opacity-60 hover:opacity-100"
      }`}
      style={{
        backgroundImage: `url(${transformedImageUrl})`,
      }}
    />
  );
};

export default ThumbnailPreview;
